/**
 * Current-user scope for client storage keys.
 *
 * All user-scoped caches (workspace IDB cache, chart-assets template
 * snapshot, …) prefix their keys with the signed-in user's sub so that
 * switching users (or simulating one from admin) gets isolated data.
 *
 * Lived in `workspace/idb-cache.ts` originally; extracted so non-workspace
 * modules can key caches per user without importing workspace internals.
 * Auth code sets this on login/restore (see `auth-provider.tsx`,
 * `account-store.ts` — they call through idb-cache's re-export).
 */

let _userSub = 'anonymous'

export function setStorageUserScope(sub: string) {
  _userSub = sub || 'anonymous'
}

export function getStorageUserScope(): string {
  return _userSub
}
